var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMbdLogoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 499 467",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0c900",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m130.48 442.21c15.11 14.9 26.27 6.9 14.22-9.21-75.78-101.34-132.66-247.75-92.11-270.01 27.33-15 73.33 58 88.49 52.96 20.52-6.82-0.16-127.96 38.58-135.12 45.59-8.42 86.68 166.55 48.48 362.16-5.97 30.58 11.69 31.33 18.22 4 73.63-308.3 7.95-439.71-64.78-432.67-80.72 7.83-62.32 137.34-62.32 137.34s-39.58-59.16-88.75-34.47c-91.92 46.14 48.26 274.04 99.97 325.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.67 47.164c14.56-6.15 77.67-28.67 85.05-12.56 8.63 18.83-40.38 34.4-33.46 59.23 5.66 20.34 105.67-24.17 116.92 16.89 10.83 39.52-46.2 52.19-106.02 72.06-41.94 13.93-24.24 61.36 18.43 51.88 72.78-16.17 156.33-62.33 128.01-136.21-20.91-54.52-96.1-34.56-96.1-34.56s16.43-21.79 4.83-43.82c-25.08-47.63-107.57 2.67-123.65 16.26-6.65 5.61-0.5 13.57 5.99 10.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.75 298.77c-11.66-58.35 179.19-73.11 179.18 36.66-0.01 83.78-179.43 127.52-210.95 127.52-11.39 0-14.7-7.63 2.83-11.74 131.78-30.88 171.34-73.55 167.11-104.22-10.7-77.75-125.77 13.82-138.17-48.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbdLogoYellow);
export default __webpack_public_path__ + "static/media/mbd-logo-yellow.b03398c5671d75a68fbf0bb328496364.svg";
export { ForwardRef as ReactComponent };